import type { ReactNode } from "react";

type Tone = "turf" | "amber" | "flag" | "ink";

const toneClasses: Record<Tone, string> = {
  turf: "text-turf-700 bg-turf-100",
  amber: "text-amber-500 bg-amber-100",
  flag: "text-flag-600 bg-flag-100",
  ink: "text-ink-600 bg-chalk-200",
};

export function MarkerBadge({
  children,
  tone = "turf",
  size = "md",
}: {
  children: ReactNode;
  tone?: Tone;
  size?: "sm" | "md";
}) {
  const sizeClasses = size === "sm" ? "h-6 px-2.5 text-[11px]" : "h-8 px-3.5 text-xs";
  return (
    <span className={`marker-badge ${sizeClasses} ${toneClasses[tone]} tracking-wide uppercase`}>
      {children}
    </span>
  );
}

export function severityTone(severity: "info" | "warn" | "danger"): Tone {
  if (severity === "danger") return "flag";
  if (severity === "warn") return "amber";
  return "turf";
}
